export default {
  overview: {
    title: "Materials Overview",
    archive_title: "Archived materials",
    subtitle: "List of all materials.",
    actions: {
      create_new: "Create New Material",
    },
    search: {
      placeholder: "eg. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Name",
        unit: "Unit",
        purchasePrice: "Purchase Price",
        createdAt: "Created at",
      },
      empty: {
        purchasePrice: "Not set",
      },
    },
  },
  detail: {
    title: "Material Details",
    actions: {
      update: "Save",
    },
    tabs: {
      general: "General",
      purchase: "Purchasing",
      files: "File storage",
      activity: "Activity",
    },
    form: {
      name: "Name",
      unit: "Unit",
      purchasePrice: "Purchase Price",
      purchaseUnit: "Purchase Price Unit",
      note: "Notes",
      sections: {
        base_data: "Master data",
        purchase: "Purchase",
        note: "Note",
      },
    },
  },
  create: {
    title: "Create Material",
    subtitle: "Create a new Material.",
  },
  component: {
    autocomplete: {
      noDataText: "Material not found {value}",
    },
  },
}
